<template>
  <div class="dialogCreateFile">
    <dialogTitle name="方案信息" />
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <div class="titel">
        <span>
          <span style="color:red"> * </span>
          <span>方案包含</span>
        </span>
        <el-form-item  prop="schemeTypes" label-position="top">
        <el-radio-group
          v-model="ruleForm.schemeTypes"
          @change="selectPrudoctType(ruleForm.schemeTypes)"
        >
          <div class="first">
            <el-radio label="GSREG">公司注册（带刻章）</el-radio>
            <el-radio label="QYJYTC1"
              >工商注册（4项含执照办理+刻章+银行开户+税务报道）</el-radio
            >
          </div>
          <div class="second">
            <el-radio label="QYJYTC2"
              >工商注册（6项含执照办理+刻章+银行开户+税务报道+代理记账1年+地址租赁1年）</el-radio
            >
          </div>
        </el-radio-group>
      </el-form-item>
      </div>

    </el-form>

    <!-- 公司注册 -->
    <template>
      <dialogTitle name="公司注册方案" />
      <el-form
        :model="gsregForm"
        :rules="gsregrules"
        ref="gsregForm"
        label-width="100px"
      >
        <el-form-item label="企业名称" prop="companyName">
          <el-input
            v-model="gsregForm.companyName"
            placeholder="请输入您的商号或公司全称（城市+商号+行业+组织形式）"
          ></el-input>
        </el-form-item>
        <el-form-item label="纳税人类型" prop="taxpayerType">
          <el-radio-group
            v-model="gsregForm.taxpayerType"
            @change="regionchange(ruleForm.schemeTypes)"
          >
            <el-radio label="一般纳税人">一般纳税人</el-radio>
            <el-radio label="小规模纳税人">小规模纳税人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="公司性质" prop="companyProperties">
          <el-radio-group
            v-model="gsregForm.companyProperties"
            @change="regionchange(ruleForm.schemeTypes)"
          >
            <el-radio label="有限公司">有限公司</el-radio>
            <el-radio label="股份有限公司">股份有限公司</el-radio>
            <el-radio label="集团公司">集团公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="公司区域" prop="area">
          <el-select
            v-model="gsregForm.area"
            placeholder="请选择公司区域"
            @change="regionchange(ruleForm.schemeTypes)"
            filterable
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="刻章服务" prop="isWhether">
          <el-radio
            v-model="gsregForm.isWhether"
            :label="true"
            @click.native.prevent="clickIsWhether()"
            >刻章包括公章、发票章、财务章、合同章、法人章</el-radio
          >
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="gsregForm.memoInfo"
            style="width: 73%"
          ></el-input>
        </el-form-item>
        <el-form-item label="办理价格">
          <p class="price">
            ￥{{ (Number(gsregForm.price) / 100).toFixed(2) }}
          </p>
        </el-form-item>
      </el-form>
    </template>

    <div class="demantFromFooter">
      <el-button type="primary" @click="submitForm()">提交方案</el-button>
    </div>
  </div>
</template>

<script>
//
import dialogTitle from "./dialogtitle";
import {
  gongshangSubmitSolution,
  gongshanggetProductPrice,
} from "@/api/alicp.js";
export default {
  props: ["itemByNeedNo", "updateSolutionNo"],
  components: {
    dialogTitle,
  },
  data() {
    return {
      areaList: [],
      ruleForm: {
        // schemeTypes: [this.itemByNeedNo.channelTypeCode],//原有公司注册根据需求信息判断
        schemeTypes: [], //公司注册套餐因百度需求不传套餐类型，因此根据前段产品类型判断（公司注册套餐1、公司注册套餐2、公司注册）
      },
      gsregForm: {
        companyName: "", //企业名称
        taxpayerType: "",
        companyProperties: "",
        area: "",
        // isWhether: false,
        price: 0,
        solutionCity: "",
        memoInfo: "",
      },

      rules: {
        schemeTypes: [
          {
            type: "string",
            required: true,
            message: "请至少选择一个方案项",
            trigger: "change",
          },
        ],
      },
      gsregrules: {
        companyName: [],
        taxpayerType: [
          {
            required: true,
            message: "请选择一个纳税人类型",
            trigger: "change",
          },
        ],
        companyProperties: [
          {
            required: true,
            message: "请选择一个公司性质",
            trigger: "change",
          },
        ],
        area: [
          {
            required: true,
            message: "请选择公司区域",
            trigger: "change",
          },
        ],
      },
      regionList: [
        "北京",
        "上海",
        "广州",
        "深圳",
        "成都",
        "开封",
        "天津",
        "青岛",
        "济南",
        "南京",
        "西安",
        "长春",
        "合肥",
        "太原",
        "苏州",
        "沈阳",
        "福州",
        "重庆",
        "郑州",
        "杭州",
        "南昌",
        "长沙",
        "武汉",
        "石家庄",
        "哈尔滨",
        //2021-5-21 新增
        "宁波",
        "温州",
        "绍兴",
        "嘉兴",
        "金华",
        "台州",
        "厦门",
        "九江",
        "洛阳",
        "许昌",
        "周口",
        "南阳",
        "宜昌",
        "襄阳",
        "岳阳",
        "常德",
        "江门",
        "珠海",
        "佛山",
        "茂名",
        "惠州",
        "东莞",
        "中山",
        "南宁",
        "海口",
        "三亚",
        "绵阳",
        "贵阳",
        "昆明",
        "保定",
        "廊坊",
        "唐山",
        "大同",
        "大连",
        "无锡",
        "徐州",
        "常州",
        "南通",
        "盐城",
        "扬州",
        "阜阳",
        "烟台",
        "潍坊",
        "西宁",
        "银川",
        "兰州",
        "芜湖",
        "呼和浩特",
        "乌鲁木齐",
      ],
      //2021-5-21新增套餐25个城市
      regionTcList: [
        "北京",
        "上海",
        "广州",
        "深圳",
        "成都",
        "开封",
        "天津",
        "青岛",
        "济南",
        "南京",
        "西安",
        "长春",
        "合肥",
        "太原",
        "苏州",
        "沈阳",
        "福州",
        "重庆",
        "郑州",
        "杭州",
        "南昌",
        "长沙",
        "武汉",
        "石家庄",
        "哈尔滨",
      ],
    };
  },
  mounted() {},
  methods: {
    //2021-5-19 新增公司注册与公司注册套餐选择的区分
    selectPrudoctType(val) {
      //清空询价相关数据
      this.gsregForm.taxpayerType = ""
      this.gsregForm.companyProperties = ""
      this.gsregForm.area = ""
      switch (val) {
        case "GSREG":
          this.areaList = this.regionList;
          this.ruleForm.schemeTypes = "GSREG";
          break;
        case "QYJYTC1":
          this.areaList = this.regionTcList;
          this.ruleForm.schemeTypes = "QYJYTC1";
          break;
        case "QYJYTC2":
          this.areaList = this.regionTcList;
          this.ruleForm.schemeTypes = "QYJYTC2";
          break;
      }
    },
    async submitForm() {
      try {
        let validates = [];
        let reqData = [];
        // for (let val of this.ruleForm.schemeTypes) {
        switch (this.ruleForm.schemeTypes) {
          case "GSREG":
            validates.push(this.validatePromise("gsregForm"));
            reqData.push({
              solutionContent: {
                solution: {
                  ...this.gsregForm,
                  regType: this.ruleForm.schemeTypes,
                  channelSolutionNo: this.updateSolutionNo
                    ? this.updateSolutionNo.channelSolutionNo
                    : undefined,
                },
              },
            });
            break;
          default:
            //包含QYJYTC1、QYJYTC2
            validates.push(this.validatePromise("gsregForm"));
            reqData.push({
              solutionContent: {
                solution: {
                  ...this.gsregForm,
                  regType: this.ruleForm.schemeTypes,
                  channelSolutionNo: this.updateSolutionNo
                    ? this.updateSolutionNo.channelSolutionNo
                    : undefined,
                },
              },
            });
            break;
        }
        console.log("reqData", reqData);
        // }
        await Promise.all([this.validatePromise("ruleForm"), ...validates]);
        this.$emit("tolkParent", { loading: true, dialog: true });
        gongshangSubmitSolution(reqData, this.$route.query.needNo).then(
          (res) => {
            if (res.status == 0) {
              this.$message({
                message: "提交方案成功！",
                type: "success",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: false,
              });
              this.gsregForm = {
                companyName: "", //企业名称
                taxpayerType: "",
                companyProperties: "",
                area: "",
                // isWhether: false,
                price: 0,
                solutionCity: "",
                memoInfo: "",
              };
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: false,
              });
              this.gsregForm = {
                companyName: "", //企业名称
                taxpayerType: "",
                companyProperties: "",
                area: "",
                price: 0,
                solutionCity: "",
                memoInfo: "",
              };
            }
          }
        );
      } catch (err) {
        this.$message({
          message: err.message || "请完善信息",
          type: "warning",
        });
      }
    },
    regionchange(val) {
      console.log(111, val);
      switch (val) {
        case "GSREG":
          if (
            this.gsregForm.area &&
            this.gsregForm.taxpayerType &&
            this.gsregForm.companyProperties
          ) {
            let params = {
              // channelItemCode: this.itemByNeedNo.channelTypeCode,//原有公司注册根据需求信息判断
              channelItemCode: this.ruleForm.schemeTypes, //公司注册套餐因百度需求不传套餐类型，因此根据前段产品类型判断（公司注册套餐1、公司注册套餐2、公司注册）
              companyProperties: this.gsregForm.companyProperties,
              taxpayerType: this.gsregForm.taxpayerType,
              pathCode: "/REG/GSREG/",
              city: this.gsregForm.area,
            };
            gongshanggetProductPrice(params).then((res) => {
              if (res.status == 0) {
                this.gsregForm.price = res.data.price;
                this.gsregForm.solutionCity = res.data.city;
              } else {
                this.gsregForm.price = 0;
                this.gsregForm.solutionCity = "";
              }
            });
          }
          break;

        case "QYJYTC1":
          if (
            this.gsregForm.area &&
            this.gsregForm.taxpayerType &&
            this.gsregForm.companyProperties
          ) {
            let params = {
              channelItemCode: this.ruleForm.schemeTypes,
              companyProperties: this.gsregForm.companyProperties,
              taxpayerType: this.gsregForm.taxpayerType,
              pathCode: "/REG/QYJYTC1/",
              city: this.gsregForm.area,
            };
            gongshanggetProductPrice(params).then((res) => {
              if (res.status == 0) {
                this.gsregForm.price = res.data.price;
                this.gsregForm.solutionCity = res.data.city;
              } else {
                this.gsregForm.price = 0;
                this.gsregForm.solutionCity = "";
              }
            });
          }
          break;

        case "QYJYTC2":
          if (
            this.gsregForm.area &&
            this.gsregForm.taxpayerType &&
            this.gsregForm.companyProperties
          ) {
            let params = {
              channelItemCode: this.ruleForm.schemeTypes,
              companyProperties: this.gsregForm.companyProperties,
              taxpayerType: this.gsregForm.taxpayerType,
              pathCode: "/REG/QYJYTC2/",
              city: this.gsregForm.area,
            };
            gongshanggetProductPrice(params).then((res) => {
              if (res.status == 0) {
                this.gsregForm.price = res.data.price;
                this.gsregForm.solutionCity = res.data.city;
              } else {
                this.gsregForm.price = 0;
                this.gsregForm.solutionCity = "";
              }
            });
          }
          break;
      }
    },
    clickIsWhether() {
      this.gsregForm.isWhether = !this.gsregForm.isWhether;
    },
    validatePromise(ref) {
      return new Promise((resolve, reject) => {
        this.$refs[ref].validate((valid) => {
          if (valid) {
            resolve("校验通过");
          } else {
            reject("请完善信息");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.dialogCreateFile {
  width: 100%;
  .el-form {
    width: 100%;
    .el-form-item {
      .el-form-item__content {
        .el-input {
          width: 400px;
          margin-right: 10px;
        }
        & > .el-input {
          width: 400px;
        }
        .el-input__inner:focus {
          border-color: #ff8a01;
        }
        .price {
          font-size: 18px;
          color: #ff8a01;
          font-weight: 500;
        }
      }
    }
  }
  .distpicker-address-wrapper select {
    width: 190px;
  }
  .distpicker-address-wrapper select:nth-child(3) {
    display: none;
  }
  .demantFromFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
